/**
 * @file Tabs 标签导航
 * @description 基于 antd Tabs 封装，支持 line（默认下划线）和 pill（胶囊）两种变体
 */
import {Tabs as AntdTabs, type TabsProps} from 'antd';
import {createCx, mergeSemanticClassNames} from '@utils/cx';
import styles from './index.module.less';

const cx = createCx(styles);

const DEFAULT_INDICATOR: TabsProps['indicator'] = {size: 24};

export interface CustomTabsProps extends TabsProps {
    variant?: 'line' | 'pill';
}

const Tabs: React.FC<CustomTabsProps> = ({
    variant = 'line',
    classNames,
    indicator,
    ...restProps
}) => {
    const isPill = variant === 'pill';

    const mergedClassNames = mergeSemanticClassNames(
        {
            header: cx('header', isPill && 'headerPill'),
            indicator: cx(!isPill && 'indicator'),
            item: cx(isPill ? 'itemPill' : 'item'),
        },
        classNames,
    );

    const mergedIndicator = isPill
        ? {size: 0}
        : indicator
          ? {...DEFAULT_INDICATOR, ...indicator}
          : DEFAULT_INDICATOR;

    return <AntdTabs classNames={mergedClassNames} indicator={mergedIndicator} {...restProps} />;
};

export default Tabs;
